/* ==========================================================================
   FlantSoul · Arma tu Look + cross-sell de ficha
   Port 1:1 del algoritmo del Next (scripts/build-catalog.mjs roleOf,
   lib/colors.ts, lib/catalog.ts armaTuLook/similares, LookBuilder.tsx),
   alimentado por el JSON público de la tienda (/products.json) y por las
   membresías de colección reales que emite el snippet datos-catalogo.
   ========================================================================== */
(function () {
  "use strict";

  var FS = window.FS || {};
  var t = FS.t || {};
  var d = document;

  var necesita = d.querySelector("[data-cross]") || d.querySelector("[data-look-builder]");
  if (!necesita) return;

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  var esc = FS.escaparHtml || function (s) { return String(s); };
  var dinero = FS.dinero || function (c) { return "$" + (c / 100).toFixed(2); };
  var interpolar = FS.interpolar || function (s) { return s; };

  /* ---------- Familias de color (lib/colors.ts) ---------- */
  var FAMILIAS = [
    ["neutral", ["denim", "black", "negro", "off white", "white", "blanco", "ivory", "marfil",
      "cream", "crema", "bone", "hueso", "pearl", "perla", "beige", "camel",
      "taupe", "brown", "cafe", "café", "mocha", "moka", "expresso", "espresso",
      "chocolate", "gray", "grey", "gris", "nude", "sand", "arena", "khaki", "tan"]],
    ["blue", ["navy", "azul", "blue", "celeste"]],
    ["red", ["wine", "vino", "burgundy", "borgoña", "terracota", "terracotta", "rust", "red", "rojo"]],
    ["pink", ["blush", "rosa", "pink", "fucsia"]],
    ["yellow", ["amarillo", "yellow", "mostaza", "mustard", "gold", "dorado"]],
    ["green", ["verde", "green", "oliva", "olive", "sage"]],
    ["print", ["floral", "print", "estampado", "animal", "leopard"]]
  ];

  function clasificarColor(color) {
    var c = String(color).toLowerCase();
    for (var i = 0; i < FAMILIAS.length; i++) {
      var kws = FAMILIAS[i][1];
      for (var j = 0; j < kws.length; j++) {
        if (c.indexOf(kws[j]) >= 0) return FAMILIAS[i][0];
      }
    }
    return null;
  }

  function familiasDe(colores) {
    var out = [];
    (colores || []).forEach(function (c) {
      var f = clasificarColor(c);
      if (f && out.indexOf(f) < 0) out.push(f);
    });
    return out;
  }

  function afinidadColor(a, b) {
    var fa = familiasDe(a);
    var fb = familiasDe(b);
    if (fa.length === 0 || fb.length === 0) return 2;
    var sa = fa.filter(function (f) { return f !== "neutral"; });
    var sb = fb.filter(function (f) { return f !== "neutral"; });
    if (sa.length === 0 || sb.length === 0) return 3;
    if (sa.some(function (f) { return sb.indexOf(f) >= 0; })) return 3;
    if (fa.indexOf("neutral") >= 0 || fb.indexOf("neutral") >= 0) return 2;
    return 0;
  }

  /* ---------- Rol de prenda (build-catalog.mjs roleOf) ---------- */
  function rolDe(hay) {
    if (/\bset\b|two.?piece|2 pieces|conjunto/.test(hay)) return "set";
    if (/dress|vestido/.test(hay)) return "dress";
    if (/jumpsuit|romper|enterizo|overall/.test(hay)) return "onepiece";
    if (/jean|pant|trouser|short|skirt|falda|jogger|leg\b|bottom/.test(hay)) return "bottom";
    if (/top|blouse|blusa|shirt|body|corset|crop|bra\b|camis/.test(hay)) return "top";
    if (/blazer|jacket|coat|chaqueta/.test(hay)) return "layer";
    return "other";
  }

  /* ---------- Catálogo vivo ---------- */
  var promesaCatalogo = null;

  function cargarCatalogo() {
    if (promesaCatalogo) return promesaCatalogo;
    var CACHE = "fs-catalogo-v1";
    try {
      var crudo = sessionStorage.getItem(CACHE);
      if (crudo) {
        var g = JSON.parse(crudo);
        if (g && g.expira > Date.now() && g.items) {
          promesaCatalogo = Promise.resolve(g.items);
          return promesaCatalogo;
        }
      }
    } catch (e) {}

    promesaCatalogo = fetch((FS.rutas && FS.rutas.raiz ? FS.rutas.raiz : "/") + "products.json?limit=250")
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var items = construir(datos.products || []);
        try {
          sessionStorage.setItem(CACHE, JSON.stringify({ expira: Date.now() + 10 * 60 * 1000, items: items }));
        } catch (e) {}
        return items;
      });
    return promesaCatalogo;
  }

  function construir(productos) {
    var fuentes = FS.fuentes || {};
    function enFuente(nombre, handle) {
      return (fuentes[nombre] || []).indexOf(handle) >= 0;
    }
    function union(nombres, handle) {
      return nombres.some(function (n) { return enFuente(n, handle); });
    }

    /* Mismas categorías del brief (build-catalog.mjs), sobre colecciones reales */
    var reSkirts = /\bskirts?\b|\bfaldas?\b|\bshorts\b/i;
    var reOccasion = /(holiday|occasion|party|night|corset|lace|gala|event)/i;

    return productos
      .filter(function (p) {
        return p.images && p.images.length && (p.variants || []).some(function (v) { return v.available; });
      })
      .map(function (p) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",").map(function (s) { return s.trim(); });
        var hayTodo = [p.title, p.product_type].concat(tags).join(" ");
        var hay = hayTodo.toLowerCase();
        var handle = p.handle;

        var cats = [];
        if (enFuente("new-arrivals", handle)) cats.push("new-arrivals");
        if (enFuente("ofertas", handle)) cats.push("sale");
        if (enFuente("body-collections", handle)) cats.push("everyday");
        if (enFuente("holiday-season", handle) || reOccasion.test([p.product_type].concat(tags).join(" "))) cats.push("special-occasion");
        if (enFuente("pants-collections", handle)) cats.push("sets");
        if (enFuente("dress", handle)) cats.push("dresses");
        if (union(["pants", "jeans", "denim", "jeans-collections"], handle)) cats.push("pants");
        if (enFuente("skirt", handle) || reSkirts.test(hayTodo)) cats.push("skirts-shorts");
        if (enFuente("enterizos", handle)) cats.push("rompers-jumpsuits");
        if (union(["top-collections", "blouses-shirts", "shirt", "bodys"], handle)) cats.push("tops-blouses");
        if (enFuente("jackets-blazers", handle) ||
          (enFuente("leather", handle) && /jacket|blazer|coat/i.test(hayTodo))) cats.push("blazers-jackets");
        if (enFuente("sport", handle)) cats.push("sport");
        if (enFuente("soleil-collection", handle)) cats.push("beachwear");
        if (enFuente("essentials", handle)) cats.push("essentials");

        var opciones = p.options || [];
        var opColor = opciones.filter(function (o) { return /color/i.test(o.name); })[0];
        var opTalla = opciones.filter(function (o) { return /size|talla/i.test(o.name); })[0];

        var precios = (p.variants || []).map(function (v) { return Math.round(parseFloat(v.price) * 100); });
        var precio = Math.min.apply(null, precios);
        var caps = (p.variants || []).map(function (v) {
          return v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null;
        });
        var cap = null;
        for (var i = 0; i < caps.length; i++) {
          if (caps[i] && caps[i] > precio) { cap = caps[i]; break; }
        }

        var disponibles = (p.variants || []).filter(function (v) { return v.available; });
        var vPrimera = disponibles[0] || (p.variants || [])[0] || {};

        var best10 = FS.best10 || [];

        return {
          handle: handle,
          url: (FS.rutas && FS.rutas.raiz ? FS.rutas.raiz : "/") + "products/" + handle,
          title: (p.title || "").trim(),
          role: rolDe(hay),
          cats: cats,
          soleil: enFuente("soleil-collection", handle),
          bestRank: best10.indexOf(handle),
          price: precio,
          compareAt: cap,
          available: disponibles.length > 0,
          colors: opColor ? opColor.values : [],
          image: p.images[0] ? p.images[0].src : "",
          imageB: p.images[1] ? p.images[1].src : "",
          variantId: vPrimera.id,
          variantTitle: vPrimera.title || "",
          variantPrice: vPrimera.price ? Math.round(parseFloat(vPrimera.price) * 100) : precio,
          sizes: opTalla ? opTalla.values : [],
          publishedAt: p.published_at
        };
      })
      .sort(function (a, b) { return new Date(b.publishedAt) - new Date(a.publishedAt); });
  }

  /* ---------- armaTuLook / similares (lib/catalog.ts) ---------- */
  var PAREJAS = {
    top: ["bottom", "layer"],
    bottom: ["top", "layer"],
    layer: ["top", "bottom"],
    dress: ["layer"],
    onepiece: ["layer"],
    set: ["layer"],
    other: ["top", "bottom", "layer"]
  };

  function armaTuLook(catalogo, p, n) {
    var buscados = PAREJAS[p.role] || PAREJAS.other;
    function puntaje(q) {
      var s = 0;
      var idx = buscados.indexOf(q.role);
      if (idx >= 0) s += (buscados.length - idx) * 10;
      if (q.available) s += 6;
      s += afinidadColor(p.colors, q.colors) * 2;
      if (q.soleil === p.soleil) s += 2;
      var compartidas = q.cats.filter(function (c) { return p.cats.indexOf(c) >= 0; }).length;
      s += Math.min(compartidas, 3);
      return s;
    }
    return catalogo
      .filter(function (q) {
        return q.handle !== p.handle && buscados.indexOf(q.role) >= 0 && afinidadColor(p.colors, q.colors) > 0;
      })
      .sort(function (a, b) { return puntaje(b) - puntaje(a) || a.title.localeCompare(b.title); })
      .slice(0, n || 4);
  }

  function similares(catalogo, p, n) {
    function puntaje(q) {
      var s = q.role === p.role ? 10 : 0;
      var compartidas = q.cats.filter(function (c) { return p.cats.indexOf(c) >= 0; }).length;
      s += compartidas * 2;
      if (q.available) s += 1;
      return s;
    }
    return catalogo
      .filter(function (q) { return q.handle !== p.handle; })
      .sort(function (a, b) { return puntaje(b) - puntaje(a); })
      .slice(0, n || 8);
  }

  /* ---------- Tarjeta de producto (espejo del snippet Liquid) ---------- */
  function urlAncho(src, w) {
    if (!src) return "";
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }

  function tarjeta(p, sizes) {
    var off = p.compareAt && p.compareAt > p.price
      ? Math.round((1 - p.price / p.compareAt) * 100)
      : 0;
    var esNueva = p.cats.indexOf("new-arrivals") >= 0;
    var colores = Math.max(1, (p.colors || []).length);
    var badges = "";
    if (off > 0) badges += '<span class="fs-badge fs-badge--tinta">−' + off + "%</span>";
    if (p.bestRank >= 0 && p.bestRank < 10 && off === 0) badges += '<span class="fs-badge fs-badge--tinta">' + esc(t.best_seller || "Best Seller") + "</span>";
    if (esNueva && off === 0) badges += '<span class="fs-badge fs-badge--claro">' + esc(t.nuevo || "New") + "</span>";
    if (p.soleil) badges += '<span class="fs-badge fs-badge--claro">' + esc(t.soleil_badge || "Soleil") + "</span>";

    return (
      '<a class="fs-card' + (p.imageB ? " tiene-b" : "") + '" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + " — " + dinero(p.price) + '">' +
      '<div class="fs-card__media">' +
      '<img class="fs-card__a" src="' + esc(urlAncho(p.image, 700)) + '" alt="' + esc(p.title) + '" loading="lazy" sizes="' + (sizes || "(min-width: 1024px) 23vw, 68vw") + '">' +
      (p.imageB ? '<img class="fs-card__b" src="' + esc(urlAncho(p.imageB, 700)) + '" alt="" loading="lazy">' : "") +
      '<div class="fs-card__badges">' + badges + "</div>" +
      (!p.available ? '<div class="fs-card__agotado">' + esc(t.agotado || "Sold out") + "</div>" : "") +
      "</div>" +
      '<h3 class="fs-card__nombre">' + esc(p.title) + "</h3>" +
      '<p class="fs-card__colores">' +
      (colores === 1 ? esc(t.un_color || "1 color") : esc(interpolar(t.colores || "{{ count }} colors", { count: colores }))) +
      "</p>" +
      '<p class="fs-card__precio tabular">' +
      (p.compareAt ? "<s>" + dinero(p.compareAt) + "</s> " : "") +
      '<span class="' + (off > 0 ? "es-oferta" : "") + '">' + dinero(p.price) + "</span></p>" +
      "</a>"
    );
  }

  /* ---------- Cross-sell del PDP ---------- */
  (function cross() {
    var zona = $("[data-cross]");
    if (!zona) return;
    var handle = zona.getAttribute("data-cross");
    cargarCatalogo().then(function (catalogo) {
      var p = catalogo.filter(function (x) { return x.handle === handle; })[0];
      if (!p) return;
      var look = armaTuLook(catalogo, p, 4);
      var rel = similares(catalogo, p, 8).filter(function (q) {
        return !look.some(function (l) { return l.handle === q.handle; });
      });

      var secLook = $("[data-cross-look]");
      if (secLook) {
        if (look.length) {
          $("[data-cross-look-grid]", secLook).innerHTML = look
            .map(function (q) { return "<li>" + tarjeta(q, "(min-width: 1024px) 25vw, 50vw") + "</li>"; })
            .join("");
          secLook.hidden = false;
        } else secLook.hidden = true;
      }
      var secRel = $("[data-cross-similares]");
      if (secRel) {
        if (rel.length) {
          $("[data-cross-similares-pista]", secRel).innerHTML = rel
            .map(function (q) {
              return '<div class="fs-rail__item">' + tarjeta(q, "(min-width: 1024px) 23vw, 62vw") + "</div>";
            })
            .join("");
          secRel.hidden = false;
          if (FS.iniciarRieles) FS.iniciarRieles(secRel.parentElement || d);
        } else secRel.hidden = true;
      }
      if (FS.observarReveals) FS.observarReveals();
    });
  })();

  /* ---------- Armador de looks (página) ---------- */
  (function armador() {
    var raiz = $("[data-look-builder]");
    if (!raiz) return;

    var SLOTS = {
      top: [["bottom"], ["layer"]],
      bottom: [["top"], ["layer"]],
      dress: [["layer"], []],
      onepiece: [["layer"], []],
      set: [["layer"], []],
      layer: [["top"], ["bottom"]],
      other: [["top", "bottom"], ["layer"]]
    };
    var ETIQUETAS = { top: t.slot_top || "The top", bottom: t.slot_bottom || "The bottom", layer: t.slot_layer || "The final layer" };
    var FILTROS = [
      { key: "all", label: t.f_all || "All" },
      { key: "dress", label: t.f_dress || "Dresses" },
      { key: "set", label: t.f_set || "Sets" },
      { key: "top", label: t.f_top || "Tops" },
      { key: "bottom", label: t.f_bottom || "Bottoms" },
      { key: "onepiece", label: t.f_onepiece || "Jumpsuits" }
    ];

    var items = null;
    var estado = { filtro: "all", base: null, idxA: 0, idxB: 0, agregado: false };

    function opcionesSlot(base, roles) {
      if (!roles.length) return [];
      function ajuste(i) {
        return afinidadColor(base.colors, i.colors) * 2 + (i.soleil === base.soleil ? 1 : 0);
      }
      return items
        .filter(function (i) {
          return i.handle !== base.handle && i.available && roles.indexOf(i.role) >= 0 &&
            afinidadColor(base.colors, i.colors) > 0;
        })
        .sort(function (a, b) { return ajuste(b) - ajuste(a); });
    }

    function miniCard(i, extra) {
      return (
        '<a class="fs-look__minicard" href="' + esc(i.url) + '">' +
        '<div class="fs-look__base-media"><img src="' + esc(urlAncho(i.image, 500)) + '" alt="' + esc(i.title) + '" loading="lazy"></div>' +
        '<p class="fs-look__nombre">' + esc(i.title) + "</p>" +
        '<p class="fs-look__precio tabular">' + dinero(i.variantPrice) + "</p>" +
        (extra || "") +
        "</a>"
      );
    }

    function pintar() {
      if (!items) {
        raiz.innerHTML = '<p class="fs-look__cargando">' + esc(t.cargando || "") + "</p>";
        return;
      }
      var base = estado.base
        ? items.filter(function (i) { return i.handle === estado.base; })[0]
        : null;

      if (!base) {
        var bases = items.filter(function (i) {
          return i.available && (estado.filtro === "all" || i.role === estado.filtro);
        });
        var html = '<div class="fs-look__filtros">';
        FILTROS.forEach(function (f) {
          html +=
            '<button type="button" class="fs-chip' + (estado.filtro === f.key ? " is-activo" : "") +
            '" aria-pressed="' + (estado.filtro === f.key) + '" data-filtro="' + f.key + '">' + esc(f.label) + "</button>";
        });
        html += "</div>";
        html +=
          '<p class="fs-look__paso"><strong>' + esc(t.paso1 || "") + "</strong> " + esc(t.paso1_cuerpo || "") + "</p>";
        html += '<ul class="fs-look__bases">';
        bases.forEach(function (i) {
          html +=
            '<li><button type="button" class="fs-look__base" data-base="' + esc(i.handle) + '">' +
            '<span class="fs-look__base-media"><img src="' + esc(urlAncho(i.image, 500)) + '" alt="' + esc(i.title) + '" loading="lazy">' +
            '<span class="fs-look__cinta">' + esc(t.elegir_base || "") + "</span></span>" +
            '<p class="fs-look__nombre">' + esc(i.title) + "</p>" +
            '<p class="fs-look__precio tabular">' + dinero(i.variantPrice) + "</p>" +
            "</button></li>";
        });
        html += "</ul>";
        raiz.innerHTML = html;
        $$("[data-filtro]", raiz).forEach(function (b) {
          b.addEventListener("click", function () {
            estado.filtro = b.getAttribute("data-filtro");
            pintar();
          });
        });
        $$("[data-base]", raiz).forEach(function (b) {
          b.addEventListener("click", function () {
            estado.base = b.getAttribute("data-base");
            estado.idxA = 0;
            estado.idxB = 0;
            pintar();
            raiz.scrollIntoView({ behavior: "smooth", block: "start" });
          });
        });
        return;
      }

      var rolesAB = SLOTS[base.role] || SLOTS.other;
      var slotA = opcionesSlot(base, rolesAB[0]);
      var slotB = opcionesSlot(base, rolesAB[1]);
      var itemA = slotA.length ? slotA[estado.idxA % slotA.length] : null;
      var itemB = slotB.length ? slotB[estado.idxB % slotB.length] : null;
      var total = base.variantPrice + (itemA ? itemA.variantPrice : 0) + (itemB ? itemB.variantPrice : 0);

      function slotHtml(nombre, opciones, idx, item) {
        if (!opciones.length) return "";
        var etiqueta = ETIQUETAS[item ? item.role : "top"] || ETIQUETAS.top;
        return (
          '<div class="fs-slot" data-slot="' + nombre + '">' +
          '<div class="fs-slot__cab"><p class="fs-slot__label">' + esc(etiqueta) + "</p>" +
          '<div class="fs-slot__flechas">' +
          '<button type="button" class="fs-slot__flecha" data-slot-mover="' + nombre + ':-1" aria-label="' + esc(interpolar(t.opcion_ant || "", { label: etiqueta })) + '"><svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M7 1L3 5l4 4" stroke="currentColor" stroke-width="1.3" fill="none"/></svg></button>' +
          '<button type="button" class="fs-slot__flecha" data-slot-mover="' + nombre + ':1" aria-label="' + esc(interpolar(t.opcion_sig || "", { label: etiqueta })) + '"><svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M3 1l4 4-4 4" stroke="currentColor" stroke-width="1.3" fill="none"/></svg></button>' +
          "</div></div>" +
          miniCard(item) +
          '<p class="fs-slot__contador tabular">' + ((idx % opciones.length) + 1) + " / " + opciones.length + " " + esc(t.opciones || "") + "</p>" +
          "</div>"
        );
      }

      var html =
        '<button type="button" class="fs-look__volver" data-volver>← ' + esc(t.cambiar_base || "") + "</button>" +
        '<div class="fs-look__slots">' +
        '<div class="fs-slot fs-slot--base"><p class="fs-slot__label" style="margin-bottom:.75rem">' + esc(t.tu_base || "") + "</p>" +
        miniCard(base) +
        "</div>" +
        slotHtml("a", slotA, estado.idxA, itemA) +
        slotHtml("b", slotB, estado.idxB, itemB) +
        "</div>" +
        '<div class="fs-look__cierre"><div>' +
        '<p class="fs-look__total-label">' + esc(t.look_completo || "") + "</p>" +
        '<p class="fs-look__total tabular">' + dinero(total) + "</p>" +
        '<p class="fs-look__tip">' + esc(t.tip || "") + "</p>" +
        "</div>" +
        '<button type="button" class="btn-ink" data-agregar-look>' +
        esc(estado.agregado ? t.look_agregado || "" : t.agregar_look || "") +
        "</button></div>";

      raiz.innerHTML = html;
      $("[data-volver]", raiz).addEventListener("click", function () {
        estado.base = null;
        pintar();
      });
      $$("[data-slot-mover]", raiz).forEach(function (b) {
        b.addEventListener("click", function () {
          var partes = b.getAttribute("data-slot-mover").split(":");
          var delta = parseInt(partes[1], 10);
          if (partes[0] === "a" && slotA.length) estado.idxA = (estado.idxA + delta + slotA.length) % slotA.length;
          if (partes[0] === "b" && slotB.length) estado.idxB = (estado.idxB + delta + slotB.length) % slotB.length;
          pintar();
        });
      });
      var btnLook = $("[data-agregar-look]", raiz);
      btnLook.addEventListener("click", function () {
        btnLook.disabled = true;
        var piezas = [base, itemA, itemB].filter(Boolean);
        var cadena = Promise.resolve();
        piezas.forEach(function (pz) {
          cadena = cadena.then(function () { return window.FSCart.agregar(pz.variantId, 1); });
        });
        cadena
          .then(function () {
            estado.agregado = true;
            btnLook.textContent = t.look_agregado || "";
            window.FSCart.abrir();
            setTimeout(function () {
              estado.agregado = false;
              if (d.contains(btnLook)) btnLook.textContent = t.agregar_look || "";
            }, 2500);
          })
          .catch(function () {})
          .then(function () { btnLook.disabled = false; });
      });
    }

    pintar();
    cargarCatalogo().then(function (catalogo) {
      items = catalogo;
      pintar();
    });
  })();
})();
